export const commonPl = {
  site_name: 'Kakobuy Spreadsheet Polska',
  site_tagline: 'Kompletny przewodnik po arkuszach produktowych',
  nav_home: 'Strona główna',
  nav_categories: 'Kategorie',
  nav_brands: 'Marki',
  nav_guides: 'Poradnik zakupowy',
  nav_blog: 'Blog',
  nav_about: 'O nas',
  nav_contact: 'Kontakt',
  btn_kakobuy_spreadsheet: 'Kakobuy Spreadsheet',
  btn_buy_now: 'Kup teraz',
  btn_learn_more: 'Dowiedz się więcej',
  btn_view_all: 'Zobacz wszystkie',
  btn_read_more: 'Czytaj więcej',
  footer_copyright: 'Wszelkie prawa zastrzeżone.',
  footer_privacy: 'Polityka prywatności',
  footer_terms: 'Warunki korzystania',
  footer_disclaimer: 'Zastrzeżenie',
  footer_cookies: 'Pliki cookie',
  all_rights_reserved: 'Wszelkie prawa zastrzeżone',
};

export default commonPl;